import {
	Component,
	Input,
	Output,
	EventEmitter,
	ChangeDetectorRef,
} from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { UsersService } from "core/users/users.service";

@Component({
	selector: "item-state-warning",
	templateUrl: "./item-state-warning.component.html",
	styleUrls: ["./item-state-warning.component.scss"],
})
export class ItemStateWarningComponent {
	@Input("item")
	item: any;

	@Output() change: EventEmitter<any> = new EventEmitter();

	working: boolean = false;
	error: string = null;

	constructor(
		public users: UsersService,
		private http: HttpClient,
		private changeDetector: ChangeDetectorRef
	) {}

	setAvailable() {
		this.working = true;
		this.error = null;
		this.http
			.post(`/api/items/${this.item.id}/available`, {})
			.subscribe(
				(data: any) => {
					this.item.state = data.state;
					this.change.emit(this.item);
				},
				(error) => {
					this.error = error.error || "Fel: " + error.status;
				}
			)
			.add(() => {
				this.working = false;
				this.changeDetector.detectChanges();
			});
	}
}
